import { useMemo } from "react";
import { motion } from "framer-motion";

const ROSE_COLORS = ["#E30B5C", "#FF5C8A", "#FFB6C1"];

const Jasmine = ({ x, y, s }) => (
  <g transform={`translate(${x} ${y}) scale(${s})`}>
    {[0, 72, 144, 216, 288].map((a) => (
      <ellipse
        key={a}
        cx="0"
        cy="-4"
        rx="2.1"
        ry="4.4"
        fill="#FFFDF5"
        stroke="#E4DCC3"
        strokeWidth="0.4"
        transform={`rotate(${a})`}
      />
    ))}
    <circle r="1.5" fill="#8FBF6E" />
  </g>
);

const Gajra = ({ rose }) => (
  <svg viewBox="0 0 44 116" width="100%" height="100%">
    <path
      d="M22 2 C12 28 32 58 20 104"
      stroke="#4C8C5C"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
    />
    <path d="M19 30 Q7 32 5 42 Q15 42 19 30" fill="#5FA36C" />
    <path d="M25 62 Q37 64 39 74 Q29 74 25 62" fill="#5FA36C" />
    <Jasmine x={17.5} y={20} s={1.05} />
    <Jasmine x={16} y={36} s={1.15} />
    <Jasmine x={19} y={52} s={1.2} />
    <Jasmine x={24} y={68} s={1.15} />
    <Jasmine x={24.5} y={82} s={1.1} />
    <Jasmine x={22.5} y={94} s={1.05} />
    <g transform="translate(20 106) scale(1.3)">
      <circle r="5" fill={rose} />
      <circle r="3.2" cx="-1" cy="-1" fill="#FF8FA3" />
      <circle r="1.6" fill="#BE0032" />
    </g>
  </svg>
);

export default function FloatingGajras({ count = 8 }) {
  const gajras = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => ({
        id: i,
        left: Math.random() * 92,
        size: 48 + Math.random() * 30,
        rise: 15 + Math.random() * 9,
        swayDuration: 2.8 + Math.random() * 2.2,
        sway: 16 + Math.random() * 24,
        delay: Math.random() * 12,
        rose: ROSE_COLORS[i % ROSE_COLORS.length],
      })),
    [count]
  );

  return (
    <div className="pointer-events-none fixed inset-0 overflow-hidden z-0" aria-hidden="true">
      {gajras.map((g) => (
        <motion.div
          key={g.id}
          className="absolute"
          style={{ left: `${g.left}%`, width: g.size, bottom: -160 }}
          animate={{ y: [0, -(window.innerHeight + 360)] }}
          transition={{ duration: g.rise, delay: g.delay, repeat: Infinity, ease: "linear" }}
        >
          <motion.div
            animate={{ x: [0, g.sway, -g.sway, 0], rotate: [0, 8, -8, 0] }}
            transition={{ duration: g.swayDuration, repeat: Infinity, ease: "easeInOut" }}
          >
            <Gajra rose={g.rose} />
          </motion.div>
        </motion.div>
      ))}
    </div>
  );
}
